// LoginCards.js
import React from "react";
import { Box } from "@mui/material";
import useLoginFlow from "../../hooks/userLoginFlow";
import LoginCardSet from "./LoginCardSet";

export default function LoginCards({ setLoading }) {
  const loginFlow = useLoginFlow(setLoading);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 591,
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
      data-testid="login-cards"
    >
      <LoginCardSet {...loginFlow} />
    </Box>
  );
}
